import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.manage-application.scim-provisioning', {
        url: '/scim-provisioning',
        component: 'companyManageApplicationScimProvisioning',
        resolve: {
            appId,
            companyId,
            provisioningDirectory
        },
    });
}

/** @ngInject */
function companyId($stateParams) {
    return $stateParams.companyId;
}

/** @ngInject */
function appId($stateParams) {
    return $stateParams.appId;
}

/** @ngInject */
function provisioningDirectory(companyId, appId, ApplicationsResource) {
    return ApplicationsResource
        .getProvisioningDirectory(companyId, appId)
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/scim-provisioning/scim-provisioning.state.js